import React, { ReactElement, useState } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import { InView } from 'react-intersection-observer';
import styles from './index.pcss';
import { showModal, hideModal } from '../../../actions/shared/modal';
import { getAllReviews } from '../../../actions/ratings';
import Dialog from '../../molecules/Dialog';
import ReviewDetails from './ReviewDetails';
import ViewAllReviewsMobile from './ViewAllReviewsMobile';
import CustomerPhotoGridModal from './ReviewCustomerPhotoGridModal/CustomerPhotoGridModal';
import { SortByReviews } from './constants';
import ReviewSinglePhotoCard from './ReviewSinglePhotoModal/ReviewSinglePhotoCard';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { getProductItemPDP, gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { getRatingParityMsiteFlag } from '../../selectors/featureFlagsSelector';

const cx = className.bind(styles);

const mapDispatchToProps = dispatch => {
  return {
    getAllReviews: (reqObj = {}) => dispatch(getAllReviews(reqObj)),
    showModal: (name, config) => dispatch(showModal(name, config)),
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
const mapStateToProps = state => ({
  ratingParityMsite: getRatingParityMsiteFlag(state)
});
const connector = connect(mapStateToProps, mapDispatchToProps);
const ProductReviewsMobile = ({
  totalRatingCount,
  totalStarCount,
  isProgressBar,
  rateData,
  customerWords,
  textReview,
  imageReview,
  noReviews,
  subRating,
  titleD,
  productCode,
  productName,
  product_id,
  product_brick,
  images,
  aggregateRating,
  isDesktop,
  featureData,
  mandatoryInfo,
  luxe,
  isSneakerHoodOn,
  sneakerHoodFeatureDataList,
  productBrand,
  getAggregateRating,
  getSubRatings,
  imageUrl,
  isSignedIn,
  getAllReviews,
  showModal,
  hideModal,
  totalReviews,
  isFleek = false,
  productData={},
  ratingParityMsite = false
}: {}): ReactElement => {
  const slicedTextReview =
    textReview && textReview.length > 2 ? textReview.slice(0, 2) : textReview;
  const [viewPhotoReviews, setPhotoReviews] = useState([]);
  const [viewallReviews, setViewAllReviews] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showHalfCard, setShowHalfCard] = useState(false);
  const [showHalfCardSingle, setShowHalfCardSingle] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const textNumberOnPhotos = (imageReview?.totalReviews > 5 && imageReview?.totalReviews - 5) || 0;
  const photosArrayToShow =
    imageReview?.totalReviews > 5
      ? imageReview?.productReviewImages.slice(0, 5)
      : imageReview?.productReviewImages;
  const productDetails = {
    productId: product_id ?? '',
    productName: productName ?? '',
    productBrick: product_brick ?? ''
  };

  const clickMorePhotos = () => {
    setShowHalfCard(true);
    fetchData(1);
    setPhotoReviews([]);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'customer photos',
      event_label: 'clicked',
      ...(product_id.length > 0 && { product_id }),
      ...(product_brick.length > 0 && { product_brick }),
      ...(productName.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
  };
  const fetchData = async pageNum => {
    try {
      const filters = {
        rating: [],
        reviewWithPhotos: true,
        verifiedPurchase: false,
        sortBy: SortByReviews[0].value,
        pageNumber: pageNum,
        skuId: product_id
      };
      setLoading(true);
      const newData = await getAllReviews(filters);
      const { productReviews } = newData.reviewData;
      setPhotoReviews(prevData => [...prevData, ...productReviews]);
      setPageNumber(pageNum);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const showHalfCardSingleClick = () => {
    setShowHalfCard(false);
    setShowHalfCardSingle(true);
  };

  const renderSinglePhotoModal = (elObj, i) => {
    showModal('reviews-single-photo', {
      state: {
        reviewsCollection: [],
        reviewData: elObj,
        loop: true,
        arrowEnabled: false,
        clickIndex: i
      }
    });
    setShowHalfCardSingle(true);
  };

  const triggerImpression = inView => {
    if (inView) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'reviews widget',
        event_label: 'seen',
        ...(product_id.length > 0 && { product_id }),
        ...(product_brick.length > 0 && { product_brick }),
        ...(productName.length > 0 && { product_name: productName }),
        pageType: 'PDP',
        store_type: 'ajio'
      });
      // Segment Push event
      segmentEventPush({
        event: 'Review Widget Viewed',
        event_category: 'reviews_rating_interactions',
        event_action: 'reviews widget',
        event_label: 'seen',
        products:[{ ...getProductItemPDP(productData)}],
        avg_ratings_of_reviews: '',
        count_of_people_found_useful: '',
        no_of_ratings_collected: '',
        review_count: '',
        review_with_images: '',
        size_and_fit_subrating: '',
        value_for_money_subrating: '',
        screen_name: 'PDP screen',       
        // pageType: 'PDP',
        store_type: 'ajio'
      });
    }
  };

  const handleViewAllReviewClick = () => {
    setViewAllReviews(!viewallReviews);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'view all',
      event_label: 'clicked',
      ...(product_id.length > 0 && { product_id }),
      ...(product_brick.length > 0 && { product_brick }),
      ...(productName.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });

    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'view all',
      event_label: 'clicked',
      products:[{ ...getProductItemPDP(productData)}],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
  };

  const gaEventOnCross = () => {
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'photo interaction',
      event_label: 'cross',
      ...(product_id.length > 0 && { product_id }),
      ...(product_brick.length > 0 && { product_brick }),
      ...(productName.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
  };

  return (
    <InView
      as="div"
      threshold={1}
      triggerOnce={true}
      onChange={(inView, entry) => triggerImpression(inView)}
    >
      <div className={cx('reviews-container', isFleek ? 'fleek-reviews-container' : '')}>
        {imageReview?.totalReviews > 0 && (
          <div className={cx('reviews-photos-section')}>
            <span
              className={cx('reviews-section-title', isFleek ? 'reviews-section-title-fleek' : '')}
            >
              <strong>Customer Photos</strong>
            </span>
            <div className={cx('reviews-section-customer-photos')} role="list" style={{display: 'flex'}}>
              {photosArrayToShow.length > 0 &&
                photosArrayToShow.map((el1, i) => {
                  const imageUrlContent = el1?.imageMap?.thumbnail;
                  const imgUrl = imageUrlContent?.length > 0 && imageUrlContent[0].imageUrl;
                  if (textNumberOnPhotos > 0 && i === 4) {
                    return (
                      <div role="listitem">
                      <div className={cx('reviews-section-image')} aria-haspopup="dialog" role="button" tabIndex={0} onClick={clickMorePhotos}>
                        <img
                          className={cx('reviews-section-img', 'blur-bg')}
                          src={`${replaceWithJioCDN(imgUrl)}`}
                          alt="Customer review image"
                        />
                        <div className={cx('reviews-section-textimage')}>
                          + {textNumberOnPhotos}
                        </div>
                      </div>
                      </div>
                    );
                  } else {
                    return (
                      <div role="listitem">
                      <div className={cx('reviews-section-image')} aria-haspopup="dialog" role="button" tabIndex={0} onClick={clickMorePhotos}>
                        <img
                          className={cx('reviews-section-img')}
                          src={`${replaceWithJioCDN(imgUrl)}`}
                          alt="Customer review image"
                        />
                      </div>
                      </div>
                    );
                  }
                })}
            </div>
          </div>
        )}
        {textReview?.length > 0 && (
          <div className={cx('reviews-review-section')}>
            <div className={cx('reviews-header')}>
              <span
                className={cx(
                  'reviews-section-title',
                  isFleek ? 'reviews-section-title-fleek' : ''
                )}
                role='heading'
                aria-level={3}
              >
                <strong>Top Reviews</strong>
              </span>
              <span
                onClick={handleViewAllReviewClick}
                className={cx(
                  'reviews-section-title2',
                  isFleek ? 'reviews-section-title2-fleek' : ''
                )}
                role='heading'
                aria-level={3}
              >
                <strong>{`View All Reviews (${totalReviews})`}</strong>
              </span>
            </div>
            {slicedTextReview?.length > 0 &&
              slicedTextReview.map(el => {
                return (
                  <ReviewDetails
                    renderSinglePhotoModal={renderSinglePhotoModal}
                    key={el.id}
                    isDesktop={false}
                    reviewData={el}
                    productDetails={productDetails}
                    isFleek={isFleek}
                    ratingParityMsite={ratingParityMsite}
                  />
                );
              })}
          </div>
        )}
        {viewallReviews && (
          <ViewAllReviewsMobile
            totalRatingCount={totalRatingCount}
            totalStarCount={totalStarCount}
            isProgressBar={isProgressBar}
            rateData={rateData}
            isDesktop
            customerWords={customerWords}
            textReview={textReview}
            imageReview={imageReview}
            noReviews={noReviews}
            subRating={subRating || ''}
            titleD={titleD}
            productCode={productCode}
            productName={productName}
            product_id={product_id}
            product_brick={product_brick}
            images={images}
            aggregateRating={aggregateRating || ''}
            featureData={featureData}
            mandatoryInfo={mandatoryInfo}
            luxe={luxe}
            isSneakerHoodOn={isSneakerHoodOn}
            sneakerHoodFeatureDataList={sneakerHoodFeatureDataList}
            productBrand={productBrand}
            getAggregateRating={getAggregateRating}
            getSubRatings={getSubRatings}
            imageUrl={imageUrl}
            isSignedIn
            showModal={showModal}
            hideModal={hideModal}
            setShowHalfCard={setShowHalfCard}
            setShowHalfCardSingle={setShowHalfCardSingle}
            renderSinglePhotoModal={renderSinglePhotoModal}
            closeModal={() => setViewAllReviews(!viewallReviews)}
          />
        )}
        <Dialog
          showDialog={showHalfCard}
          type="drawer"
          customContentWrapperClass={isFleek ? 'reviews-fleek' : 'reviews'}
          customContentClass={isFleek ? 'fleek-reviews-dialog' : ''}
          onCancel={() => {
            setShowHalfCard(false);
          }}
        >
          <CustomerPhotoGridModal
            app="MSITE"
            pageNumber={pageNumber}
            fetchData={fetchData}
            loading={loading}
            viewPhotoReviews={viewPhotoReviews}
            showHalfCardSingleClick={showHalfCardSingleClick}
            isFleek={isFleek}
            productDetails={productDetails}
          />
        </Dialog>
        <Dialog
          showDialog={showHalfCardSingle}
          customClass="review-msite-od"
          type="drawer"
          customContentWrapperClass={isFleek ? 'reviews-fleek' : 'reviews'}
          customContentClass={isFleek ? 'fleek-reviews-dialog' : ''}
          onCancel={() => {
            gaEventOnCross();
            setShowHalfCardSingle(false);
            hideModal('reviews-single-photo');
          }}
        >
          <ReviewSinglePhotoCard productDetails={productDetails} isFleek={isFleek} />
        </Dialog>
      </div>
    </InView>
  );
};

export default connector(ProductReviewsMobile);
